import { Box } from '@mui/material'
import { DataGrid, GridColDef, GridRowsProp } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'
import CustomSwitchComponent from '../../../../../../shared/components/buttons/SwitchCustom'
import { MassivelyAssign } from '../../../hooks/modals/massive-assign/useMassiveAssignState'

interface MenuListProps {
  massivelyAssign: MassivelyAssign
  handleMenuChange: (value: any) => void
}

export function MenuList({ massivelyAssign, handleMenuChange }: MenuListProps) {
  const { t } = useTranslation(['global'])

  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  const menuRows: GridRowsProp<{ id: number; name: string; type: string }> = authUser.menus ?? []
  const menuColumns: GridColDef[] = [
    { headerName: t('name'), field: 'name', flex: 1 },
    {
      headerName: t('admin.people.linked'),
      field: 'type',
      renderCell: (params: any) => (
        <Box display="flex" alignItems="center" gap={8}>
          <CustomSwitchComponent
            // color={(massivelyAssignData['menus'][rowData.id] !== undefined && massivelyAssignData['menus'][rowData.id] < userIds.length) ? "secondary" : "primary" }
            checked={massivelyAssign.menus.includes(params.id)}
            onChange={() => handleMenuChange(params.row)}
          />
        </Box>
      )
    }
  ]

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '800px' }}>
      <DataGrid rows={menuRows} columns={menuColumns} disableColumnMenu />
    </div>
  )
}
